import api from './api';

export const getOperationalProfiles = async () => (await api.get('/admin/operational-profiles')).data;
export const createOperationalProfile = async (payload) => (await api.post('/admin/operational-profiles', payload)).data;
export const createOperationalProfileVersion = async (profileId, configuration) => (
    await api.post(`/admin/operational-profiles/${profileId}/versions`, { configuration })
).data;
export const publishOperationalProfileVersion = async (versionId) => (
    await api.post(`/admin/operational-profile-versions/${versionId}/publish`)
).data;
export const getOperationalAssignments = async () => (await api.get('/admin/operational-config/assignments')).data;
export const getOperationalTerminalStatus = async () => (await api.get('/admin/operational-config/terminals')).data;
export const getTerminalModels = async () => (await api.get('/admin/terminal-models')).data;
export const createTerminalModel = async (payload) => (await api.post('/admin/terminal-models', payload)).data;
export const assignTerminalModel = async (serialNumber, terminalModelId) => (
    await api.put(`/admin/terminals/${encodeURIComponent(serialNumber)}/model`, { terminal_model_id: terminalModelId })
).data;
export const createOperationalAssignment = async (payload) => (
    await api.post('/admin/operational-config/assignments', payload)
).data;
export const getEffectiveOperationalConfiguration = async (serialNumber) => (
    await api.get(`/admin/operational-config/effective/${encodeURIComponent(serialNumber)}`)
).data;
